export default __webpack_public_path__ + "static/media/case2.514c1448.webp";